export interface ItemSettings {
  excluded?: boolean;
  checked?: boolean;
  beltId?: string;
  wagonId?: string;
}
